import React from 'react';

import Header4 from '../components/headers/Header4';
import Features4 from '../components/features/Features4';
import CallToAction2 from '../components/call-to-action/CallToAction2';
import Footer2 from '../components/footers/Footer2';

export default function Index() {
  return (
    <React.Fragment>
      <Header4 content={null} />

      <Features4 content={null} />

      <CallToAction2 content={null} />

      <Footer2 content={null} />
    </React.Fragment>
  );
}

